import { ChevronDown, ChevronRight } from "lucide-react";
import { cx } from "../cx";

export function GroupHeader({
  colSpan,
  label,
  count,
  note,
  collapsed,
  onToggle,
  attention = false,
}: {
  colSpan: number;
  label: string;
  count: number;
  note: string;
  collapsed: boolean;
  onToggle: () => void;
  attention?: boolean;
}) {
  return (
    <tr>
      <th
        colSpan={colSpan}
        scope="rowgroup"
        className="h-9 border-b border-divider bg-surface px-2 text-left text-ui font-normal"
      >
        <button
          type="button"
          aria-expanded={!collapsed}
          onClick={onToggle}
          className="sticky left-2 inline-flex items-center gap-1.5 rounded-md px-1 py-0.5 hover:bg-surface-2"
        >
          {collapsed ? <ChevronRight size={13} aria-hidden="true" /> : <ChevronDown size={13} aria-hidden="true" />}
          <span className={cx("font-semibold", attention ? "text-attention" : "text-fg")}>{label}</span>
          <span className="font-mono text-xs text-muted">{count}</span>
          <span className="text-muted">{note}</span>
        </button>
      </th>
    </tr>
  );
}
